export const INSTANCE_BASED_CLUSTER = 'Instance-Based Cluster';
export const ELASTIC_CLUSTER = 'Elastic Cluster';
export const SERVERLESS_INSTANCE_CLASS = 'db.serverless';
export const PRODUCTION = 'Production';
